import { render, staticRenderFns } from "./general-collective-settings.vue?vue&type=template&id=7f33d535&"
import script from "./general-collective-settings.vue?vue&type=script&lang=js&"
export * from "./general-collective-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports